var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ab-button--white ab-button--cancel",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.$t("app.cancel"))+" "),_c('i',{staticClass:"icon-close"})])
}
var staticRenderFns = []

export { render, staticRenderFns }